/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoFusionModelsDefaultImage,
    SharedserviceMelcoFusionModelsDefaultImageFromJSON,
    SharedserviceMelcoFusionModelsDefaultImageFromJSONTyped,
    SharedserviceMelcoFusionModelsDefaultImageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoFusionModelsUserBlankListItem
 */
export interface SharedserviceMelcoFusionModelsUserBlankListItem {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    canvas_width?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    canvas_height?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    views_count?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    colors_count?: number;
    /**
     * 
     * @type {SharedserviceMelcoFusionModelsDefaultImage}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    default_image?: SharedserviceMelcoFusionModelsDefaultImage;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoFusionModelsUserBlankListItem
     */
    updated_date?: Date | null;
}

export function SharedserviceMelcoFusionModelsUserBlankListItemFromJSON(json: any): SharedserviceMelcoFusionModelsUserBlankListItem {
    return SharedserviceMelcoFusionModelsUserBlankListItemFromJSONTyped(json, false);
}

export function SharedserviceMelcoFusionModelsUserBlankListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoFusionModelsUserBlankListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'canvas_width': !exists(json, 'canvas_width') ? undefined : json['canvas_width'],
        'canvas_height': !exists(json, 'canvas_height') ? undefined : json['canvas_height'],
        'views_count': !exists(json, 'views_count') ? undefined : json['views_count'],
        'colors_count': !exists(json, 'colors_count') ? undefined : json['colors_count'],
        'default_image': !exists(json, 'default_image') ? undefined : SharedserviceMelcoFusionModelsDefaultImageFromJSON(json['default_image']),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
    };
}

export function SharedserviceMelcoFusionModelsUserBlankListItemToJSON(value?: SharedserviceMelcoFusionModelsUserBlankListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'canvas_width': value.canvas_width,
        'canvas_height': value.canvas_height,
        'views_count': value.views_count,
        'colors_count': value.colors_count,
        'default_image': SharedserviceMelcoFusionModelsDefaultImageToJSON(value.default_image),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
    };
}


